import { getFirestore } from 'firebase/firestore'
import { getFunctions, httpsCallable } from '@firebase/functions'

export const useGetFirestore = () => {
  const config = useRuntimeConfig()
  return getFirestore(config.public.FIRESTORE_DATABASE_ID as string)
}

export const useHttpsCallable = async <
  RequestData = unknown,
  ResponseData = unknown,
>(
  functionName: string,
  data?: RequestData,
  composableOptions?: {
    onSuccess?: (data: any) => void
    onError?: (error: string) => void
  },
): Promise<ResponseData | undefined> => {
  /* const { $i18n } = useNuxtApp()
  const toast = usePrimevueToast() */

  try {
    const functions = getFunctions()
    const httpsCallableFunction = httpsCallable<RequestData, ResponseData>(
      functions,
      functionName,
    )
    const response = (await httpsCallableFunction(data)) as ResponseData
    if (composableOptions?.onSuccess) composableOptions.onSuccess(response)
    return response
  }
  catch (detail) {
    const { $sentryCaptureException } = useNuxtApp()
    $sentryCaptureException(`Error while requesting data from ${functionName}: ${detail}`)

    /* toast.add({
      severity: 'error',
      summary: $i18n.t('common.label.error'),
      detail,
      life: 5000,
    }) */

    if (composableOptions?.onError) composableOptions.onError(detail as string)
    throw new Error(detail as string)
  }
}
